import { DefinitionMeta } from '@/components/types'

import HclBlocks from '@/components/Blocks/Blocks.vue'
import HclBlock from '@/components/Block/Block.vue'
import HclBlockContentEmpty from '@/components/BlockContentEmpty/BlockContentEmpty.vue'
import HclBlockContentList from '@/components/BlockContentList/BlockContentList.vue'
import HclBlockContentSearchForm from '@/components/BlockContentSearchForm/BlockContentSearchForm.vue'
import HclBlockContentForm from '@/components/BlockContentForm/BlockContentForm.vue'
import HclBlockContentHtml from '@/components/BlockContentHtml/BlockContentHtml.vue'
import HclToolbar from '@/components/Toolbar/Toolbar.vue'
import HclEmpty from '@/components/Empty/Empty.vue'

const useMeta = (): any => {

  const componentMeta = (meta: DefinitionMeta) => {
    if (meta.type === 'blocks' && meta.version === 1) {
      return HclBlocks
    }

    if (meta.type === 'block' && meta.version === 1) {
      return HclBlock
    }

    if (meta.type === 'toolbar' && meta.version === 1) {
      return HclToolbar
    }

    if (meta.type === 'empty' && meta.version === 1) {
      return HclEmpty
    }

    if (meta.type === 'block-content-empty' && meta.version === 1) {
      return HclBlockContentEmpty
    }

    if (meta.type === 'block-content-html' && meta.version === 1) {
      return HclBlockContentHtml
    }

    if (meta.type === 'content-list' && meta.version === 1) {
      return HclBlockContentList
    }

    if (meta.type === 'search-form' && meta.version === 1) {
      return HclBlockContentSearchForm
    }

    if (meta.type === 'form' && meta.version === 1) {
      return HclBlockContentForm
    }

    return HclEmpty
  }

  const attributesMeta = (meta: DefinitionMeta) => {
    const keys = (meta && Object.keys(meta)) ?? []

    const result = {}
    for (const d of keys) {
      result["data-hcl-" + d] = meta[d]
    }

    return result
  }

  return {
    componentMeta,
    attributesMeta
  }
}

export {
  useMeta
}
